<div class="container pt-3">
	<ul class="nav nav-tabs mb-3">
		<li class="nav-item" *ngFor="let link of navLinks">
			<a class="nav-link" [routerLink]="link.url" routerLinkActive="active">
				<i class="mr-1" [ngClass]="link.iconClass"></i>{{ link.label }}
			</a>
		</li>
	</ul>
</div>

<router-outlet></router-outlet>
